/* stylelint-disable no-descending-specificity */
import { css } from '@sitebase/emotion';
import { rgba, darken } from 'polished';
import { colorPrimary500 as darkBlue, colorYellow500 as yellow, fontDefaults } from '../settings';

var lightBlue = '#003387';
var fixedHeight = 56;
var distanceBetweenLines = 2;
var lineWidth = 0.6;
var angle = 123;
var fadeArea = 76;
var fadeOutGradient = 'linear-gradient(\n  180deg,\n  ' + rgba(darkBlue, 0) + ',\n  ' + darkBlue + ' ' + fadeArea + 'px,\n  ' + darkBlue + '\n)';
var stripes = 'repeating-linear-gradient(\n  ' + angle + 'deg,\n  ' + darkBlue + ',\n  ' + darkBlue + ' ' + distanceBetweenLines + 'px,\n  ' + lightBlue + ' ' + distanceBetweenLines + 'px,\n  ' + lightBlue + ' ' + (distanceBetweenLines + lineWidth) + 'px\n)';
var indentation = 'linear-gradient(\n  ' + angle + 'deg,\n  ' + rgba(darkBlue, 0) + ',\n  ' + rgba(darkBlue, 0) + ' 45px,\n  ' + darkBlue + ' 45px,\n  ' + darkBlue + '\n)';
var yellowLine = 'linear-gradient(\n  ' + angle + 'deg,\n  ' + rgba(darkBlue, 0) + ',\n  ' + rgba(darkBlue, 0) + ' 44px,\n  ' + darken(0.1, yellow) + ' 44px,\n  ' + darken(0.1, yellow) + ' 46px,\n  ' + rgba(darkBlue, 0) + ' 46px,\n  ' + rgba(darkBlue, 0) + '\n)';
var indentationElement = '&::before {\n        content: \'\';\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 55px;\n        height: 100%;\n        background: ' + indentation + ', ' + yellowLine + ';\n  }';

var _ref = ';font-size:14px;height:';
var _ref2 = ';display:flex;background:';
var _ref3 = ';width:100%;color:white;';
export var titleHeader = function titleHeader(stretched) {
  return (/*#__PURE__*/css(fontDefaults, _ref, stretched ? '100%' : fixedHeight + 'px', _ref2, darkBlue, _ref3)
  );
};

var _ref4 = 'padding:0 45px 0 20px;flex:1;background:';
var _ref5 = ';position:relative;&::after{content:\'\';position:absolute;top:0;right:0;width:100%;height:100%;background:';
var _ref6 = ';}';
var _ref7 = ';';
export var titleHeaderContainer = function titleHeaderContainer(hasIndentation) {
  return (/*#__PURE__*/css(_ref4, stripes, _ref5, fadeOutGradient, _ref6, hasIndentation && indentationElement, _ref7)
  );
};
export var titleHeaderContent = /*#__PURE__*/css('display:flex;align-items:center;height:', fixedHeight, 'px;position:absolute;z-index:1;transition:0.5s;& > *:not(:last-child){margin-right:12px;}');
export var actionSlotContainer = /*#__PURE__*/css('padding-right:20px;height:', fadeArea, 'px;');
export var actionSlotContent = /*#__PURE__*/css('display:flex;align-items:center;height:', fixedHeight, 'px;& > *{min-width:24px;}& > *:not(:first-child){margin-left:12px;}');
export var fadeOut = /*#__PURE__*/css('opacity:0;transform:translateX(-20px);z-index:0;');